import { useKeyFeaturesContext } from "@omni/ui/components/Product/Feature/KeyFeatures/context/keyFeatures.context";
import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Features = ({ className, children }: Props) => {
    const { keyFeatures } = useKeyFeaturesContext();

    return (
        <ul className={cn(className)}>
            <Mapped array={keyFeatures}>{children}</Mapped>
        </ul>
    );
};
